import type { ReactNode } from 'react';
import { UnifiedThemeProvider } from '@backstage/theme';
import {
  arriveLightUnifiedTheme,
  arriveDarkUnifiedTheme,
} from '../../themes/createUnifiedArriveTheme';

export const arriveLightAppTheme = {
  id: 'arrive-light',
  title: 'Arrive Light',
  variant: 'light' as const,
  Provider: ({ children }: { children: ReactNode }) => (
    <UnifiedThemeProvider theme={arriveLightUnifiedTheme} themeName="arrive">
      {children}
    </UnifiedThemeProvider>
  ),
};

export const arriveDarkAppTheme = {
  id: 'arrive-dark',
  title: 'Arrive Dark',
  variant: 'dark' as const,
  Provider: ({ children }: { children: ReactNode }) => (
    <UnifiedThemeProvider theme={arriveDarkUnifiedTheme} themeName="arrive">
      {children}
    </UnifiedThemeProvider>
  ),
};
